/**
 * @generated SignedSource<<c5c7d0d88301d21f5ef6ef214f9bf88b>>
 * @relayHash 3b13ce5a1ead386852d30e6220d696ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 351e8ed663fceca6c76060046675d36c2ba86b6cbb1bd318c7ce386827de46fd

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateSingleSelectFieldInput = {
  id: string;
  operation: JiraSingleSelectOperationInput;
};
export type JiraSingleSelectOperationInput = {
  fieldOption?: string | null | undefined;
  id?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$variables = {
  input: JiraUpdateSingleSelectFieldInput;
};
export type lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$data = {
  readonly jira: {
    readonly updateSingleSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateSingleSelectField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldId: string;
        readonly fieldOption: {
          readonly color: {
            readonly colorKey: string | null | undefined;
            readonly id: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly optionId: string;
          readonly value: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation = {
  rawResponse: lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$rawResponse;
  response: lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$data;
  variables: lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "lite_issueFieldSingleSelectInlineEditFull_SingleSelectInlineEditViewIsEditable_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "JiraOption",
                    "kind": "LinkedField",
                    "name": "fieldOption",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "value"
                      },
                      {
                        "concreteType": "JiraColor",
                        "kind": "LinkedField",
                        "name": "color",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "colorKey"
                          },
                          (v4/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "optionId"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "351e8ed663fceca6c76060046675d36c2ba86b6cbb1bd318c7ce386827de46fd",
    "metadata": {},
    "name": "lite_singleSelect_issueFieldSingleSelect_SingleSelectField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4efc8e08a4925bceb3af2c617ed6d9ee";

export default node;
